import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "Models/Folder";

class FolderManager extends Controller {
	constructor(name) {
		super(name);
	}

	getByReference (referenceGuid, referenceType) {
		let data = { item: { referenceGuid, referenceType } };
		const rd = NousCore.api.createRequest(data);
	
		return NousCore.api.send("folder/get-by-reference", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);
	
						return {
							data: folderList,
							status: "ok"
						}
						break;
					case 404:
						return {
							data: "",
							status: "ko"
						}
						break;
				}
			}
		});
	}

	getListByAgent (parentFolder, agentGuid = null) {
		let data = { item: { parentGuid: "", ownerGuid: agentGuid || Shark.get("currUser").guid } };
	
		if (parentFolder && parentFolder.guid !== "") {
			data.item.parentGuid = parentFolder.guid;
		}
		if (parentFolder && parentFolder.guid !== "" && parentFolder.ownerGuid !== "") {
			data.item.ownerGuid = parentFolder.ownerGuid;
		}
	
		const rd = NousCore.api.createRequest(data);
	
		return NousCore.api.send("folder/get-list-by-agent", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);
	
						folderList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
						});
	
						if (parentFolder) {
							Shark.set("currFolder", parentFolder);
						}
	
						Shark.set({folderList});
	
						folderManager.emit("listChanged");
						return {
							data: folderList,
							status: "ok"
						}
						break;
					case 404:
						folderManager.emit("listGetError");
						return {
							data: "",
							status: "ko"
						}
						break;
				}
			}
		});
	}

	getListByAreaManager (parentFolder, agents = []) {
		let data = { item: { parentGuid: "", ownerGuids: [...agents.map(item => item.guid), Shark.get("currUser").guid] } };
	
		if (parentFolder && parentFolder.guid !== "") {
			data.item.parentGuid = parentFolder.guid;
		}
		if (parentFolder && parentFolder.guid !== "" && parentFolder.ownerGuid !== "") {
			data.item.ownerGuid = parentFolder.ownerGuid;
		}
	
		const rd = NousCore.api.createRequest(data);
	
		return NousCore.api.send("folder/get-list-by-area-manager", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);
	
						folderList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
						});
	
						if (parentFolder) {
							Shark.set("currFolder", parentFolder);
						}
	
						Shark.set({folderList});
	
						folderManager.emit("listChanged");
						return {
							data: folderList,
							status: "ok"
						}
						break;
					case 404:
						folderManager.emit("listGetError");
						return {
							data: "",
							status: "ko"
						}
						break;
				}
			}
		});
	}
	
	getPathByGuid (guid) {
		let data = { item: { guid } };
		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("folder/get-path-by-guid", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);
						folderList.reverse();

						return {
							data: folderList,
							requestedAction: "get-path-by-guid",
							status: "ok"
						}
					case 404:
						return {
							data: "",
							requestedAction: "get-path-by-guid",
							status: "ko"
						}
				}
			}
		});
	}




	
	delete (folder) {
		const rd = NousCore.api.createRequest({ item: folder.export() });

		return NousCore.api.send("folder/delete", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.get("folderList");

						if (folderList) {
							const folderIndex = Utils.safp(folderList, "guid", folder.guid, "index");

							if (folderIndex > -1) {
								folderList.splice(folderIndex, 1);
							}
						}

						folderManager.emit("deleted");
						folderManager.emit("listChanged");
						break;
					case 404:
						folderManager.emit("deleteError");
						return {
							data: "",
							status: "ko",
						}
						break;
				}
			}
		});
	}

	getList (parentFolder) {
		let data = { item: { parentGuid: "" } };

		if (parentFolder) {
			data.item.parentGuid = parentFolder.guid;
		}

		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("folder/get-list", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);

						folderList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
						});

						if (parentFolder) {
							Shark.set("currFolder", parentFolder);
						}

						// const documentListPath = documentList.map(item => item.section); 
						// const documentMap = { "/":{
						// 	documents: [],
						// 	subFolders: {}}
						// };
						// const documentTree = folderManager.extractDocumentFolder({}, documentList, documentMap);

						// console.log({ documentTree, documentListPath, documentMap});

						// Shark.set("documentMap", documentMap);
						// Shark.set("documentTree", documentTree);
						Shark.set({folderList});

						folderManager.emit("listChanged");
						return {
							data: folderList,
							status: "ok",
						}
						break;
					case 404:
						folderManager.emit("listGetError");
						return {
							data: "",
							status: "ko",
						}
						break;
				}
			}
		});
	}

	getPath (item) {
		let data = { item };
		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("folder/get-path", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);
						folderList.reverse();

						return {
							data: folderList,
							status: "ok"
						}
					case 404:
						return {
							data: "",
							status: "ko"
						}
				}
			}
		});
	}

	getPathByReferenceGuid (referenceGuid, referenceType) {
		let data = { item: { referenceGuid, referenceType } };
		const rd = NousCore.api.createRequest(data);

		return NousCore.api.send("folder/get-path-by-reference-guid", rd)
		.then(function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const folderList = Shark.getInstanceList("Folder", data.items);
						folderList.reverse();

						return {
							data: folderList,
							requestedAction: "get-path-by-reference-guid",
							status: "ok"
						}
					case 404:
						return {
							data: "",
							requestedAction: "get-path-by-reference-guid",
							status: "ko"
						}
				}
			}
		});
	}

	save (folder) {
		const rd = NousCore.api.createRequest({ item: folder.export() });
		const action = folder.guid === "" ? "insert" : "update";

		return NousCore.api.send(`folder/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						folder.import(data.items[0]);
						folder.clean();

						let folderList = Shark.get("folderList");

						if (!folderList) {
							folderList = [];
						}
						if (action === "insert") {
							folderList = [folder, ...folderList];
						}
						else {
							folderList = [...folderList];
						}

						folderList.sort((a, b) => {
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							else if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
						});

						Shark.set({
							editingFolder: null,
							folderList
						});

						folderManager.emit("saved");
						folderManager.emit("listChanged");
						return {
							data: folder,
							status: "ok"
						}
						break;
					case 99:
						folderManager.emit("saveError");
						return {
							data: "",
							status: "ko"
						}
						break;
				}
			}
		});
	}
}

const folderManager = new FolderManager("folderManager");

Shark.registerController(folderManager);

export { folderManager };
